@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.required-indicator {
  color: var(--red-600);
  vertical-align: super;
  line-height: 10px;
}
